import moment from 'moment-timezone';

import { EditReference } from './EditReference';

// IANA timezone list never changes at runtime, so it's a sync
// `items` source — no fetch, no loading state. Built once at module
// load.
const timeZones: readonly string[] = moment.tz.names();

interface Props {
  readonly value: string | null;
  readonly onChange: (value: string | null) => void;
  /** Floating label. Omit to render a bare control (the caller supplies its own label). */
  readonly label?: string;
  /** What an empty field means, shown in it — e.g. the zone it falls back to. */
  readonly placeholder?: string;
  readonly mandatory?: boolean;
  readonly disabled?: boolean;
}

const identity = (s: string): string => s;

/**
 * Searchable dropdown for IANA timezone names. Thin wrapper over
 * `EditReference` that supplies the timezone list so the caller
 * doesn't have to know about the underlying LOV mechanics.
 */
export const EditTimeZoneReference = ({ value, onChange, label, placeholder, mandatory, disabled }: Props) => (
  <EditReference<string>
    label={label}
    value={value}
    onChange={onChange}
    source={timeZones}
    getKey={identity}
    getLabel={identity}
    placeholder={placeholder}
    mandatory={mandatory}
    disabled={disabled}
  />
);
